// API base URL (no trailing slash).
// Dev: REACT_APP_API_URL from environments/*.env (frontend :3000 → Django :8000).
// Production: same origin as the page so each tenant always hits its own backend.
function resolveApiUrl() {
  if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
    return window.location.origin;
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:8000';
}

export const apiURL = resolveApiUrl();
